<form #contactNoForm="ngForm">
    <div class="phone-field">
        <div class="phone">
            <app-input [type]="'text'" name="phone" [formGroup]="contactNoForm" (input)="formatPhoneNumber($event)"
                label="Phone number *" [placeholder]="'Phone number'" [(ngModel)]="this.userProfile.phone"
                pattern="^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$" required
                (ngModelChange)="userProfileChange.emit(userProfile)"></app-input>
        </div>
    </div>

    <app-marketing-info  [userProfile]="userProfile" [elementName]="elementName"></app-marketing-info>
    <app-form-navigation-buttons *ngIf="showFormNavigationBtn" [form]="contactNoForm" [userProfile]="userProfile"></app-form-navigation-buttons>
</form>
